<template>
  <v-container>
    <div class="mt-3 pa-1 indi hidden-xs-only" v-if="currentMusicItem().chapters.length != 0">
      <v-btn color="info" to="/music" flat>Back to Music</v-btn>
      <div class="indi_info">
        <i v-if="currentMusicItem().chapterheading">{{ currentMusicItem().chapterheading }}</i>
        <i v-else>Individual pieces from this book also for sale to download or print</i>

      </div><v-divider></v-divider>

      <div class="mb-4" style="font-size: 10px;">Below link(s) lead to our Amazon and/or listings. We may make a
        commission from qualified purchases from these link(s). For more information, see <router-link
          to="/privacy">Privacy Policy and Disclosure</router-link>.</div>
      <Chapter v-for="chapter in currentMusicItem().chapters" v-bind:key="chapter" :image="chapter.image"
        :title="chapter.title" :link="chapter.link">
      </Chapter>
    </div>

    <v-btn color="info" to="/music" flat>Back to Music</v-btn>
    <MusicBook :title="currentMusicItem().title" :subtitle="currentMusicItem().subtitle"
      :author="currentMusicItem().author" :subtext="currentMusicItem().subtext" :link="currentMusicItem().link"
      :images="currentMusicItem().images" :audioDescription="currentMusicItem().audioDescription"
      :sampleAudio="currentMusicItem().sampleAudio" :amazonLink="currentMusicItem().amazonLink"
      :alternateAmazon="currentMusicItem().alternateAmazon" :amazonURL="currentMusicItem().amazonURL"
      :itemImage="currentMusicItem().itemImage" :chapters="currentMusicItem().chapters"
      :buttons="currentMusicItem().buttons">
      <div v-html="currentMusicItem().sampleVideo" slot="video"></div>
      <div v-html="currentMusicItem().amazonLink" slot="amazon"></div>
      <div v-html="currentMusicItem().alternateAmazon" slot="alternateAmazon"></div>
      <div v-html="currentMusicItem().description" slot="description"></div>
    </MusicBook>
  </v-container>
</template>

<script>
import MusicBook from "./MusicBook.vue";
import Chapter from "./Chapter.vue";
import artists from "../data/artist-data";

export default {
  name: "BookDetails",
  mounted() {
    this.$root.checkCookie()
  },
  components: {
    MusicBook,
    Chapter
  },
  props: {
    title: String
  },
  methods: {
    currentMusicItem() {
      // console.log(music[this.title.replaceAll("-", " ")].sampleVideo)
      var spacedTitle = this.title.replace(/-/g, " ")
      for (const artist of artists) {
        for (const book of artist.books) {
          if (book.title == spacedTitle) {
            return book
          }
        }
      }
    }

  },
  computed: {
    console: () => console,
    window: () => window,
  },
  head: {
    title: {
      inner: "Sonive Publishing",
      separator: "-",
      complement: "Our Music"
    },
    meta: [
      {
        name: 'description',
        content: 'Check out newly released and up-and-coming classical compositions.'
      }
    ]
  }
};
</script>

<style>
.indi_info {
  width: 100%;
  font-size: 16px;
}

.indi {
  margin: auto;
  width: 900x;
}
</style>